import colors from './colors'

/**
 * Used for matching background colors and foreground colors
 */
const fills = {
  neutral: {
    color: colors.gray800,
    backgroundColor: colors.gray200
  },
  blue: {
    color: colors.blue600,
    backgroundColor: colors.blue100
  },
  red: {
    color: colors.red700,
    backgroundColor: colors.red100
  },
  orange: {
    color: colors.orange700,
    backgroundColor: colors.orange100
  },
  yellow: {
    color: colors.yellow800,
    backgroundColor: colors.yellow100
  },
  green: {
    color: colors.green700,
    backgroundColor: colors.green100
  },
  teal: {
    color: colors.teal800,
    backgroundColor: colors.teal100
  },
  purple: {
    color: colors.purple600,
    backgroundColor: colors.purple100
  }
}

export default fills
